import template from './sourceErrorsModal.html';
import controller from './sourceErrorsModal.controller';

let sourceErrorsModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default sourceErrorsModalComponent;



// WEBPACK FOOTER //
// ./app/components/sourceErrorsModal/sourceErrorsModal.component.js